import React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {selectIsReschedule} from '../../selectors/commonSelector';
import {SmallCard} from '../../lib/small-card/small-card';
import {CardChildren} from '../../lib/card-children/card-children';
import {RootMachineContext} from '../../machines/rootMachine';
import {selectReason} from '../../selectors/cancellation-selector';

import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';

import css from './reason-success.css';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';


export const ReasonSuccess = () => {
  const {t} = useLabelTranslation();
  const reason = RootMachineContext.useSelector(selectReason);
  const isReschedule = RootMachineContext.useSelector(selectIsReschedule);

  return (
    <SmallCard
      title={
        isReschedule
          ? t(
              'Reschedule_request_has_been_sent',
              'Reschedule request has been sent',
            )
          : t(
              'Your_meeting_has_been_cancelled',
              'Your meeting has been cancelled',
            )
      }
      icon="face-confused"
    >
      <CardChildren>
        <div className={css.cancelSuccess}>
          <Textarea
            label={
              isReschedule
                ? t('Reason_for_reschedule', 'Reason for reschedule')
                : t('Reason_for_cancelling', 'Reason for cancelling')
            }
            textCountLimit={150}
            locked={true}
            value={reason}
          />
          {isReschedule && (
            <InContextAlert semantic="success">
              {t(
                'A_notification_requesting_the_guest_to_reschedule_has_been_sent',
                'A notification requesting the guest to reschedule has been sent',
              )}
            </InContextAlert>
          )}
        </div>
      </CardChildren>
    </SmallCard>
  );
};
